import React from 'react';
import {
  Box,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  useDisclosure,
  Center,
  Divider,
  Flex,
  Link,
  Button,
  Text,
} from '@chakra-ui/react';
import ProjectItem from '../projectItem';
import 'react-awesome-slider/dist/styles.css';
import '../styles/spec-list.css';
import { RiComputerLine } from 'react-icons/ri';
import { PiDotOutlineLight } from 'react-icons/pi';

const TOOL_GROUPS = [
  {
    title: 'Front-End Development',
    items: [
      ['Languages & Markup', 'HTML, CSS, JavaScript'],
      ['Templating', 'Django Template'],
    ],
  },
  // {
  //   title: 'Back-End & Server-Side',
  //   items: [
  //     ['Framework', 'Django'],
  //     ['Programming Language', 'Python'],
  //   ],
  // },
];

export default function Project2() {
  const title = 'Web Developer Internship';
  const subtitle = 'UnixDev Co.,Ltd';
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <div>
      <div className="card-container" onClick={onOpen}>
        <ProjectItem
          title={title}
          subtitle={subtitle}
          tags={['Django', 'Python', 'JavaScript']}
        />
      </div>

      <Modal
        onClose={onClose}
        size={{ base: 'full', lg: '4xl' }}
        isOpen={isOpen}
        scrollBehavior={'inside'}
        isCentered
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader pb={4}>
            {title}
            <Box className="eyebrow" mt={1}>
              {subtitle}
            </Box>
            <Divider mt={4} />
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Box className="eyebrow" mb={3}>
              OVERVIEW
            </Box>
            <Box>
              <Text className="modal-copy">
                Built and shipped full-stack features for a client web
                application on Django (Python) — writing the backend logic and
                views, then wiring them up to the interface with Django
                templates, HTML, CSS, and native JavaScript.
              </Text>
            </Box>
            <Box mt={6}>
              <Text className="modal-copy">
                My first stretch of professional development work: taking
                coursework-level Python into code that had to hold up inside a
                real product, and learning how to move around an existing
                codebase rather than starting every project from an empty file.
              </Text>
            </Box>

            <Box className="eyebrow" mt={12} mb={6}>
              TOOLS
            </Box>
            <div className="spec-grid">
              {TOOL_GROUPS.map(group => (
                <div className="spec-group" key={group.title}>
                  <div className="spec-group__title">{group.title}</div>
                  <dl className="spec-list">
                    {group.items.map(([label, value]) => (
                      <div className="spec-row" key={label}>
                        <dt className="spec-row__label">{label}</dt>
                        <dd className="spec-row__value">{value}</dd>
                      </div>
                    ))}
                  </dl>
                </div>
              ))}
            </div>

            <Box className="eyebrow" mt={12} mb={3}>
              WORKING PERIOD
            </Box>
            <Flex mt={3}>
              <Center gap={2}>
                <Box fontFamily="mono" fontSize={13}>
                  Jun 2020 — Jul 2020
                </Box>
                <PiDotOutlineLight />
                <Box fontFamily="mono" fontSize={13} color="ink-dim">
                  ( 2 months )
                </Box>
              </Center>
            </Flex>

            <Box className="eyebrow" mt={12} mb={3}>
              COMPANY
            </Box>
            <Box mt={3}>
              <Link href="https://www.unixdev.co.th/" target="_blank">
                <Button colorScheme="brand" variant="outline">
                  {subtitle}
                </Button>
              </Link>
            </Box>

            <Center mt={12}>
              <Divider mr={5} />
              <RiComputerLine size={50} />
              <Divider ml={5} />
            </Center>
          </ModalBody>
        </ModalContent>
      </Modal>
    </div>
  );
}
